import { render } from "./FormInput.vue?vue&type=template&id=c8772b46&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c8772b46"

export default script